<template>
  <vetalfa-dialog
    v-on:dialogClose="close"
    :toggleModel="model"
    :smallHeader="false"
    :fullscreen="true"
    persistent
    :maxWidth="`${width}px`"
    v-if="user"
  >
    <template v-slot:header>
      <v-row class="ma-0 pa-0" style="height: 120px">
        <v-btn
          absolute
          @click="model = false"
          small
          fab
          elevation="5"
          class="ma-2 pa-0 purchases-close-btn"
        >
          <v-icon color="white" class="ma-0 pa-0">{{ mdiClose }}</v-icon>
        </v-btn>
        <v-img
          class="pa-0 ma-0"
          :src="pro"
          style="z-index: 1"
          height="160"
          :width="width + 10"
        >
          <template v-slot:placeholder>
            <v-row
              color=""
              class="fill-height vetalfa-background ma-0"
              align="center"
              justify="center"
            >
            </v-row>
          </template>
        </v-img>
        <div class="triangle-bottom-right"></div>
        <div class="triangle-bottom-left"></div>
      </v-row>
      <v-row class="ma-0 pa-0 px-5" style="z-index: 2">
        <v-row
          align="start"
          justify="center"
          class="ma-0 pa-0 vetalfa-row purchases-card"
        >
          <v-row align="center" justify="center" class="ma-0 pa-0">
            <v-col
              class="ma-0 pa-0 vetalfa-big-title"
              style="
                padding-right: 80px !important;
                padding-left: 80px !important;
                padding-top: 32px !important;
                word-break: break-word;
              "
              cols="12"
            >
              <p class="ma-0 pa-0 text-center">Venha ser Vet Alfa PRO</p>
            </v-col>
            <v-col class="ma-0 pa-0">
              <p class="ma-0 pa-0 text-center vetalfa-tab-text black--text">
                Assine por
                <span class="text-decoration-line-through">R$49,90</span>
                <span class="font-weight-bold"> R$39,90/mês.</span>
              </p>
            </v-col>
            <v-col cols="12" class="ma-0 pa-0 mt-3">
              <v-row class="ma-0 pa-0" justify="center">
                <v-btn
                  x-large
                  :loading="loading"
                  class="text-none white--text"
                  color="primary"
                  @click="purchasesOrder"
                >
                  Experimentar por 30 dias grátis
                </v-btn>
              </v-row>
            </v-col>
            <v-col class="ma-0 pa-0 mt-3">
              <p class="ma-0 pa-0 vetalfa-subtitle text-center black--text">
                (Condições válidas para os primeiros assinantes)
              </p>
            </v-col>
            <v-col
              v-if="featuresNumber > 0"
              cols="12"
              class="ma-0 pa-0 px-2 mt-5"
            >
              <p
                class="ma-0 pa-0 px-4 text-start black--text vetalfa-card-text font-weight-bold"
              >
                Acesso ilimitado à:
              </p>
            </v-col>
            <v-col
              v-if="featuresNumber > 0"
              cols="12"
              class="ma-0 pa-0 px-2 mt-2"
            >
              <p
                class="ma-0 pa-0 px-4 text-start vetalfa-card-text black--text"
              >
                Diagnósticos Diferenciais
              </p>
            </v-col>
            <v-col
              v-if="featuresNumber > 0"
              cols="12"
              class="ma-0 pa-0 px-2 mt-2"
            >
              <p
                class="ma-0 pa-0 px-4 text-start vetalfa-card-text black--text"
              >
                Interações medicamentosas
              </p>
            </v-col>
            <v-col
              v-if="featuresNumber > 0"
              cols="12"
              class="ma-0 pa-0 px-2 mt-2"
            >
              <p
                class="ma-0 pa-0 px-4 vetalfa-card-text text-start black--text vetalfa-break-word"
              >
                Primeiros algoritmos veterinários interativos do mundo (15 de
                Março)
              </p>
            </v-col>
            <v-col
              v-if="featuresNumber > 0"
              cols="12"
              class="ma-0 pa-0 px-2 mt-2"
            >
              <p
                class="ma-0 pa-0 px-4 text-start vetalfa-card-text black--text"
              >
                Calculadoras e Escores exclusivos
              </p>
            </v-col>
            <v-col
              v-if="featuresNumber > 0"
              cols="12"
              class="ma-0 pa-0 px-2 mt-2"
            >
              <p
                class="ma-0 pa-0 px-4 vetalfa-card-text text-start black--text"
              >
                Doenças sumarizadas (Abril/23)
              </p>
            </v-col>
            <v-col cols="12" class="my-5">
              <p
                class="ma-0 px-4 pt-5 mt-5 text-center vetalfa-subtitle black--text vetalfa-break-word"
              >
                Assinaturas renovadas automaticamente. Cancele a qualquer
                momento.
                <span>{{ _getLabel("LOGIN_FOOTER_TEXT_1") }}</span>
                <span
                  @click="
                    openExternalUrl({
                      url: _getParameter('TERMS_URL'),
                      inAppBrowser: true,
                    })
                  "
                  class="pa-0 ma-0 text-decoration-underline"
                >
                  {{ _getLabel("USE_TERMS_TITLE") }}
                </span>
                <span>{{ _getLabel("LOGIN_FOOTER_TEXT_2") }}</span>
                <span
                  @click="
                    openExternalUrl({
                      url: _getParameter('POLICIES_URL'),
                      inAppBrowser: true,
                    })
                  "
                  class="pa-0 ma-0 text-decoration-underline"
                >
                  {{ _getLabel("PRIVACY_POLICIES_TITLE") }}
                </span>
              </p>
            </v-col>
          </v-row>
          <div class="purchases-card-tag">
            <div class="purchases-card-tag-text">-20%</div>
          </div>
        </v-row>
      </v-row>
    </template>
  </vetalfa-dialog>
</template>

<style>
.purchases-body {
  margin: 0px;
  padding: 24px;
  background: transparent;
  z-index: 2;
  height: 100%;
}

.triangle-bottom-left {
  width: 0;
  height: 0;
  position: absolute;
  top: 140px;
  left: 0px;
  z-index: 2;
  border-bottom: 60px solid white;
  border-right: 60px solid transparent;
}

.triangle-bottom-right {
  width: 0;
  height: 0;
  position: absolute;
  top: 140px;
  right: 0px;
  z-index: 2;
  border-bottom: 60px solid white;
  border-left: 60px solid transparent;
}

.purchases-card {
  border-radius: 32px 32px 0px 0px;
  background-color: white;
}
.purchases-card-tag {
  border-radius: 0px 32px 0px 0px;
  background: linear-gradient(45deg, white 50%, #004662 0%, #004662 100%);
  top: 120px;
  content: "-20%";
  display: block;
  height: 76px;
  width: 76px;
  position: absolute;
  right: 16px;
  text-align: center;
  line-height: 64px;
}
.purchases-card-tag-text {
  color: white;
  font-size: 16px;
  transform: rotate(45deg) translate(5%, -20%);
}
.purchases-close-btn {
  z-index: 1000000;
  top: calc(0px + env(safe-area-inset-top));
  top: calc(0px + constant(safe-area-inset-top));
  background-color: rgba(0, 0, 0, 0.4) !important;
}
</style>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";

import { purchasesOrder } from "@/plugins/purchases.plugins.js";
import { mdiSync, mdiClose } from "@mdi/js";
import images from "@/constants/images.js";
export default {
  name: "Purchases",
  data() {
    return {
      purchasesOrder,
      mdiClose,
      mdiSync,
      model: false,
      pro: images.PRO,
      width: 0,
    };
  },
  mounted() {
    this.offsetDialogProportions();
  },
  computed: {
    ...mapGetters("general", ["user", "isPremium"]),
    ...mapGetters("purchases", ["products", "purchasesModel", "loading"]),
    purchaseData() {
      return this.user.purchaseData;
    },
    featuresNumber() {
      const windowHeight = this._getWindowHeight();
      if (windowHeight > 640) {
        return 4;
      } else if (windowHeight > 575) {
        return 2;
      }
      return 0;
    },
  },
  methods: {
    ...mapActions("general", ["openExternalUrl"]),
    ...mapMutations("purchases", ["setPurchasesModel"]),
    offsetDialogProportions() {
      this.model = false;
      this.$nextTick(() => {
        this.width = this._getWindowWidth();
        this.width = this.width > 600 ? 600 : this.width;
      });
    },
    close() {
      this.model = false;
    },
  },
  watch: {
    purchasesModel(val) {
      if (val) {
        this.model = true;
      }
    },
    model(val) {
      if (!val) {
        this.setPurchasesModel(val);
      }
    },
  },
};
</script>